import React, { useContext } from 'react';
import { ActionsContext } from '../context/actions.context';
import { MobileView } from '../config/mediaQuery';

type Props = {
};

const FullScreenContainer = (props: Props) => {
  const { allScreens = [] } = useContext(ActionsContext);
  return <MobileView>
    {(
      allScreens.length > 0 && (
        allScreens.map(({ view }, index) => {
          return (
            <div
              key={`${view.title}${index}`}
              style={{
                position: 'absolute',
                height: 'calc(100% - 80px)',
                width: '100%',
                backgroundColor: 'white',
                zIndex: 1000,
                overflow: 'hidden',
              }}
            >
              {view}
            </div>
          )
        })
      )
    )}
  </MobileView>
};

export default FullScreenContainer;
